import { render, staticRenderFns } from "./CurrencySelector.vue?vue&type=template&id=04790f7a&"
import script from "./CurrencySelector.vue?vue&type=script&lang=js&"
export * from "./CurrencySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../checkout/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports